import { fromJS, List } from 'immutable';

import Snapshot from 'models/SnapshotModel';
import CompanyMap from 'models/CompanyMapModel';
import BatchProgress from 'models/BatchProgressModel';

import {
  entitiesBatch,
  companiesSnapshots,
  postCompanyMap,
  updateCompanyMap,
  ADD_COMPANY_TO_IMPORT,
  SSE_UPDATE_BATCH_PROGRESS,
  ADD_COMPANIES_LIST_TO_IMPORT,
  REMOVE_COMPANY_FROM_IMPORT,
  CLEAR_COMPANIES_LIST_IMPORT,
} from './types';

export * from './actions';

const initialState = fromJS({
  network: {
    loading: false,
    error: false,
  },
  notifySSE: false,
  batchId: null,
  companyMap: {
    data: {},
    network: { loading: false, error: false },
  },
  snapshots: {
    data: [],
    network: { loading: false, error: false },
  },
  connectedCompanies: [],
  batchProgress: {},
});

const setEntitiesBatchRequest = (state) => state.setIn(['network', 'loading'], true);

const setEntitiesBatchSuccess = (state, action) =>
  state.withMutations((s) =>
    s
      .setIn(['network', 'loading'], false)
      .setIn(['network', 'error'], false)
      .setIn(['companyMap', 'data'], CompanyMap.deserialize(action.companyMap))
      .set('batchId', action.batchId),
  );

const setEntitiesBatchError = (state, action) =>
  state.withMutations((s) =>
    s.setIn(['network', 'loading'], false).setIn(['network', 'error'], action.error),
  );

const updateCompanyMapRequest = (state) => state.setIn(['companyMap', 'network', 'loading'], true);

const updateCompanyMapSuccess = (state, action) =>
  state.withMutations((s) =>
    s
      .setIn(['companyMap', 'network', 'loading'], false)
      .setIn(['companyMap', 'network', 'error'], false)
      .setIn(['companyMap', 'data'], CompanyMap.deserialize(action.companyMap)),
  );

const updateCompanyMapError = (state, action) =>
  state.withMutations((s) =>
    s
      .setIn(['companyMap', 'network', 'loading'], false)
      .setIn(['companyMap', 'network', 'error'], action.error),
  );

const postCompanyMapRequest = (state) => state.setIn(['companyMap', 'network', 'loading'], true);

const postCompanyMapSuccess = (state, action) =>
  state.withMutations((s) =>
    s
      .setIn(['companyMap', 'network', 'loading'], false)
      .setIn(['companyMap', 'network', 'error'], false)
      .set('batchProgress', BatchProgress.deserialize(action.progressData)),
  );

const postCompanyMapError = (state, action) =>
  state.withMutations((s) =>
    s
      .setIn(['companyMap', 'network', 'loading'], false)
      .setIn(['companyMap', 'network', 'error'], action.error),
  );

const setCompaniesSnapshotsRequest = (state) =>
  state.setIn(['snapshots', 'network', 'loading'], true);

const setCompaniesSnapshotsRequestSuccess = (state, action) =>
  state.withMutations((s) =>
    s
      .setIn(['snapshots', 'network', 'loading'], false)
      .setIn(['snapshots', 'network', 'error'], false)
      .setIn(['snapshots', 'data'], List(action.snapshots.map(Snapshot.deserialize))),
  );

const setCompaniesSnapshotsRequestError = (state, action) =>
  state.withMutations((s) =>
    s
      .setIn(['snapshots', 'network', 'loading'], false)
      .setIn(['snapshots', 'network', 'error'], action.error),
  );

const addCompanyToImport = (state, action) =>
  state.withMutations((s) =>
    s.update('connectedCompanies', (list) => list.push(fromJS(action.companyNumber))),
  );

const addCompaniesListToImport = (state, action) =>
  state.withMutations((s) =>
    s.update('connectedCompanies', (list) => list.concat(fromJS(action.companiesNumbers))),
  );

const removeCompanyFromImport = (state, action) =>
  state.withMutations((s) =>
    s.update('connectedCompanies', (list) =>
      list.filter((company) => company !== action.companyNumber),
    ),
  );

const clearCompaniesListImport = (state, action) =>
  state.withMutations((s) =>
    s.update('connectedCompanies', (list) =>
      list.filter((company) => !action.companiesNumbers.includes(company)),
    ),
  );

const updateBatchProcess = (state, action) =>
  state.set('batchProgress', BatchProgress.deserialize(action.payload));

const entitiesBatchReducer = (state = initialState, action) => {
  switch (action.type) {
    case entitiesBatch.request:
      return setEntitiesBatchRequest(state, action);
    case entitiesBatch.success:
      return setEntitiesBatchSuccess(state, action);
    case entitiesBatch.failure:
      return setEntitiesBatchError(state, action);

    case updateCompanyMap.request:
      return updateCompanyMapRequest(state, action);
    case updateCompanyMap.success:
      return updateCompanyMapSuccess(state, action);
    case updateCompanyMap.failure:
      return updateCompanyMapError(state, action);

    case postCompanyMap.request:
      return postCompanyMapRequest(state, action);
    case postCompanyMap.success:
      return postCompanyMapSuccess(state, action);
    case postCompanyMap.failure:
      return postCompanyMapError(state, action);

    case companiesSnapshots.request:
      return setCompaniesSnapshotsRequest(state, action);
    case companiesSnapshots.success:
      return setCompaniesSnapshotsRequestSuccess(state, action);
    case companiesSnapshots.failure:
      return setCompaniesSnapshotsRequestError(state, action);

    case ADD_COMPANY_TO_IMPORT:
      return addCompanyToImport(state, action);
    case ADD_COMPANIES_LIST_TO_IMPORT:
      return addCompaniesListToImport(state, action);
    case REMOVE_COMPANY_FROM_IMPORT:
      return removeCompanyFromImport(state, action);
    case CLEAR_COMPANIES_LIST_IMPORT:
      return clearCompaniesListImport(state, action);
    case SSE_UPDATE_BATCH_PROGRESS:
      return updateBatchProcess(state, action);

    default:
      return state;
  }
};

export default entitiesBatchReducer;
